<template>
  <VaInnerLoading v-if="!loading" :key="$route.fullPath" :loading="routerLoadingState">
    <router-view :class="!routerLoadingState || `blur`" />
  </VaInnerLoading>
  <template v-else>
    <div class="min-h-screen bg-gray-100 text-gray-900 flex justify-center">
      <div class="max-w-screen-xl m-0 sm:m-10 bg-white shadow sm:rounded-lg flex justify-center flex-1">
        <div class="lg:w-1/2 xl:w-5/12 p-6 sm:p-12">
          <div>
            <img src="@/assets/uwb.png" class="w-32 mx-auto" />
          </div>
          <div class="mt-12 flex flex-col items-center">
            <h1 class="text-2xl xl:text-3xl font-extrabold">
              System zgłaszania publikacji
            </h1>

            <div class="w-full flex-1 mt-4">
              <div class="flex flex-col items-center">
                <div v-if="!error"
                  class="w-full max-w-xl font-bold rounded-lg py-2 flex items-center justify-center transition-all duration-300 ease-in-out">
                  <div class="bg-white p-2 rounded-full">
                    <div role="status">
                      <svg aria-hidden="true" class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-uwbPrim"
                        viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor" />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill" />
                      </svg>
                      <span class="sr-only">Ładowanie...</span>
                    </div>
                  </div>
                  <span class="ml-4">
                    Trwa ładowanie aplikacji...
                  </span>
                </div>
                <VaAlert color="danger" class="mb-6" v-if="error">
                  Wystąpił błąd aplikacji, prosimy spróbować ponownie później.
                </VaAlert>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>
<script setup>
import { wait } from '@/API.js'

import { ref, onMounted } from 'vue'
import { useToast, useColors } from 'vuestic-ui';
import { useUserStore } from './stores/user-store';
import { useGlobalStore } from './stores/global-store';
import { storeToRefs } from 'pinia';

const userStore = useUserStore()
const globalStore = useGlobalStore()
const { applyPreset } = useColors()
const loading = ref(true)
const error = ref(false)
const { routerLoadingState } = storeToRefs(globalStore)

onMounted(async () => {
  try {
    let preset = localStorage.getItem('darkmodepreset') || 'light'
    applyPreset(preset)
    if (preset == 'dark') {
      document.body.classList.add('dark')
    } else {
      document.body.classList.remove('dark')
    }
    const loadingToastId = await useToast().init({ message: `Ładowanie aplikacji...`, color: 'primary' })
    await wait(300)
    const [user] = await Promise.all([userStore.getUserSession(), globalStore.getAppConfig()])
    loading.value = false
    await useToast().close(loadingToastId)
    if (user == null) {
      await useToast().init({ message: `Przekierowywanie do logowania`, color: `warning`, duration: 1000 })
    } else {
      await useToast().init({ message: `Witaj ponownie ${user.firstName}!`, color: 'success', duration: 1000 })
    }

  } catch (err) {
    await useToast().init({ message: `Wystąpił błąd podczas pobierania danych: ${err}`, color: 'danger', duration: 5000 })
    error.value = true
    console.error(err)
  }
})
</script>
<style lang="scss">
@import 'scss/main.scss';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
